import { Pipe, PipeTransform } from '@angular/core';
import { isDarkColor } from 'src/app/lib/is-dark-color';
import { parseColor } from '../lib/parse-color';

@Pipe({
  name: 'isDarkColor',
  standalone: true,
})
export class IsDarkColorPipe implements PipeTransform {
  transform(color: string): boolean {
    if (!color) return false;
    const { r, g, b } = parseColor(color);
    return isDarkColor(r, g, b);
  }
}
